export const blogData = [
    {
        id: 1,
        title: 'SCRAPING BILLBOARD AND IMDB USING PYTHON SELENIUM',
        description: 'Here we will use Selenium to navigate between web pages, and try to scrape data from them.',
        date: 'Aug 7, 2020',
        image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTZL1J6NwjE0TogaBBCL3oAAIbHL2eFacjxkg&s',
        url: 'https://hackzism.blogspot.com/2020/07/scraping-billboard-and-imdb-using.html'
    },

    {
        id: 2,
        title: 'Artificial Intelligence for Sentiment Analysis',
        description: 'How Ai is used to explained sentimental analysis to identify and interpret the emotional tone behind, including text, voice, and social media conversations.',
        date: 'Dec 13, 2025',
        image: 'https://blogger.googleusercontent.com/img/a/AVvXsEjLOReXvl05CB6NYEFcRywHB5uJwh1nSTHpvBkeSLxnANKru5NB37OF0zIRf0G3dB8wj8Xmi9wpNWK0OvM57yaTyC589fDgn7VVe8yHEXrlffThf6p6dszbyge3_y58pGNrkQAKB1DurkQeX4cthbdubZZa7_R4HOxEuo-vpkqLZXrqQqte0WT-usUKia74=w674-h265',
        url: 'https://aiinsentimentanalysis.blogspot.com/2026/04/what-your-customers-really-mean.html'
    },

    {
        id: 3,
        title: 'GOOGLE AI GEMMA 4: A Game Changer in AI Development',
        description: 'Gemma 4 an unprecedented level of intelligence-per-parameter. This breakthrough builds on incredible community momentum.',
        date: 'Apr 4, 2026',
        image: 'https://blogger.googleusercontent.com/img/a/AVvXsEhvsBuMvO1M3nsx7_OSBWWYQ-Hz7NCgGlTdJcF5dilvQI4XjyKa6qul80jeezo4Q6RJU9zLluo06F4Y5n3pQhjdYaxF1cuoqsQWEwH8OodoDm0GPpQwpzI-upZX_lqz_oIXcc26o5WkZv7rfcMxXcKPbyCdN-PZmIQgkRhANTBN1ib6qvdCx37lOHVea9g=w615-h346',
        url: 'https://googlegema4model.blogspot.com/'
    },
    {
        id: 4,
        title: 'BEING ANONYMOUS: A BEGINNERS GUIDE',
        description: 'Here are some basic ways to lay off the Radar',
        date: 'Aug 14, 2020',
        image: 'https://blogger.googleusercontent.com/img/a/AVvXsEjuYDf4LwU7L4uB9a_jX_kYtchrGCjPVtItO7PpF-MKD5oLxdXNQ4QVX_rPeQQk40wRlyVq34J8aHsZvnJZtgZq36eqcbUDti5RO9B3pVoRmB2HrxMxAzd7eGZwtKOKNqTzFzta61-skFplxwWuKQZMAk56CI0YNBICeajcYapWFIL3ZYD3XUG4JJeQDao=w945-h600-p-k-no-nu',
        url: 'https://hackzism.blogspot.com/2020/06/being-anonymous-beginners-guide.html'
    },

    {
        id: 5,
        title: 'CHECK WEATHER FROM TERMINAL USING WTTR.IN',
        description: 'wttr.in is a console-oriented weather forecast service that supports various information representation methods like ANSI-sequences for console HTTP clients, HTML, or PNG.',
        date: 'Aug 11, 2022',
        image: 'https://1.bp.blogspot.com/-OW7jX57tea4/XvnGxuEOslI/AAAAAAAABW0/R8lVT1AXDSwnvE0EGA9Ra49-LDm1ACwDgCK4BGAsYHg/s1216/wttr1.png',
        url: 'https://hackzism.blogspot.com/2020/06/check-weather-from-terminal-using-wttrin.html'
    }, 

   
]




// Do not remove any fields.
// Leave it blank instead as shown below.


/* 
{
    id: 1,
    title: 'Car Pooling System',
    description: '',
    date: 'Oct 1, 2020',
    image: '',
    url: 'https://preview.colorlib.com/theme/rezume/'
}, 
*/